<template>
  <modal
    scrollable
    class="review-modal"
    :visible="shown"
    @on-close="onClose"
  >
    <div class="review-form">
      <div class="review-form__inputs-wrap">
        <div class="review-form__title">
          Оcтавить отзыв
        </div>

        <div class="review-form__inputs-wrap-user">
          <ui-input
            ref="name"
            v-model="name"
            placeholder="Имя"
            label="Имя*"
            validate="name"
            clearable
          />

          <ui-city-suggest
            label="Город*"
            :current="{ id: cityValue.id, name: cityValue.name }"
            @change="setCity"
          />
        </div>
      </div>
      <div class="review-form__stats-wrap">
        <stars-input
          ref="rating"
          required
          class="review-form__main-rating"
          label="Оценка товара*"
          large
          error-message="Оцените товар"
          v-model="rating"
          label-left="ужасно"
          label-right="отлично"
        />

        <div class="review-form__inputs-group">
          <stars-input
            class="review-form__secondary-rating"
            label="Посадка"
            v-model="fitRating"
          />

          <stars-input
            class="review-form__secondary-rating"
            label="Качество"
            v-model="qualityRating"
          />

          <stars-input
            class="review-form__offset-rating"
            label="Соответствие фото"
            v-model="photoAccuracyRating"
          />
        </div>

        <review-radio-stats
          ref="size"
          class="review-form__size"
          label="Размер*"
          v-model="size"
          :options="sizeOptions"
          required
          error-message="Выберите размер"
        />

        <review-radio-stats
          label="Срок использования"
          v-model="timeUsage"
          :options="timeUsageOptions"
        />
      </div>
      <div class="review-form__inputs-wrap review-form__inputs-wrap-text">
        <input-group-head
          label="Достоинства"
          large
          class="review-form__textarea-label"
        />
        <ui-textarea
          v-model="advantages"
          :height="textareaHeight"
          placeholder="Что вам понравилось?"
          class="review-form__textarea"
        />

        <input-group-head
          label="Недостатки"
          large
          class="review-form__textarea-label"
        />
        <ui-textarea
          v-model="disadvantages"
          :height="textareaHeight"
          placeholder="Что не оправдало ваших ожиданий?"
          class="review-form__textarea"
        />

        <input-group-head
          label="Отзыв о товаре*"
          large
          class="review-form__textarea-label"
        />
        <ui-textarea
          v-model="review"
          :height="textareaHeight"
          placeholder="Поделитесь вашими впечатлениями о товаре"
          class="review-form__textarea"
          @focus="clearError"
          :error="reviewError"
        />

        <ui-checkbox
          v-model="recommended"
          label="Я рекомендую этот товар к покупке"
          class="review-form__checkbox"
        />

        <ui-button
          ref="submitBtn"
          :disabled="!isValuesValid"
          @click="submit"
          wide
          text="Оставить отзыв"
        />

        <div class="review-form__agreement">
          Нажимая на кнопку «Оставить отзыв»,
          вы принимаете условия
          <a target="_blank" href="/agreement">пользовательского соглашения</a>
          и <a target="_blank" href="/content_rules">правила публикации пользовательского контента</a>
        </div>
      </div>
    </div>
  </modal>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import StarsInput from './stars-input.vue';
import ReviewRadioStats from './review-radio-stats.vue';
import UiTextarea from '../kit/ui-textarea/ui-textarea.vue';
import InputGroupHead from '@kit/input-group-head/input-group-head.vue';
import UiButton from '../kit/ui-button/ui-button.vue';
import { productGtmEvents } from '@/gtm/product';

export default {
  name: "review-modal",

  components: {
    StarsInput,
    ReviewRadioStats,
    UiTextarea,
    InputGroupHead,
    UiButton
  },

  inject: ["adaptive"],

  props: {
    shown: {
      type: Boolean,
      default: false,
    },
    productCode: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      name: "",
      cityValue: {
        id: null,
        name: null,
      },
      rating: 0,
      fitRating: 0,
      qualityRating: 0,
      photoAccuracyRating: 0,
      size: '',
      sizeOptions: [
        {
          label: 'Маломерит',
          value: 'small_size',
        },
        {
          label: 'Соответствует',
          value: 'match_size',
        },
        {
          label: 'Большемерит',
          value: 'large_size',
        },
      ],
      timeUsage: '',
      timeUsageOptions: [
        {
          label: 'Меньше недели',
          value: 'less_week'
        },
        {
          label: 'Около месяца',
          value: 'about_month'
        },
        {
          label: 'Больше полугода',
          value: 'over_six_months'
        },
      ],
      advantages: "",
      disadvantages: "",
      review: "",
      reviewError: "",
      recommended: false,
    };
  },

  computed: {
    ...mapGetters('user',['account', 'accountCity']),

    isValuesValid() {
      const isNameValid = this.$refs.name?.valid;
      const isRatingValid = this.$refs.rating?.valid;
      const isSizeValid = this.$refs.size?.valid;
      const isReviewValid = this.review.length > 0;

      return isNameValid && isRatingValid && isSizeValid && isReviewValid;
    },
    textareaHeight() {
      if (this.adaptive.isTablet || this.adaptive.isDesktop) {
        return 80;
      }

      return 120;
    }
  },

  created() {
    this.setCity({ id: this.accountCity.id, name: this.accountCity.name });
    this.name = this.account.firstName;
  },

  methods: {
    ...mapActions('product', ['addReview']),

    onClose() {
      this.$emit('close');
    },
    scrollToError() {
      this.$nextTick(() => {
        const error = document.querySelector('.error');

        if(!error) return;

        error.scrollIntoView({behavior: "smooth", block: "center"});
      })
    },
    clearError() {
      this.reviewError = '';
    },
    validate() {
      const isNameValid = this.$refs.name.checkValidOutside();
      const isRatingValid = this.$refs.rating.checkValidOutside();
      const isSizeValid = this.$refs.size.checkValidOutside();
      const isReviewValid = this.review.length > 0;

      if (!isReviewValid) {
        this.reviewError = 'Напишите несколько слов';
      }

      if(!isNameValid || !isRatingValid || !isSizeValid || !isReviewValid) {
        this.scrollToError();
      }

      return isNameValid && isRatingValid && isSizeValid && isReviewValid;
    },
    setCity({ id, name } = {}) {
      this.cityValue.id = id;
      this.cityValue.name = name;
    },
    async submit() {
      productGtmEvents.reviews.submitReview({ productCode: this.productCode });

      if (this.validate()) {
        await this.addReview({
          rating: this.rating,
          fitRating: this.fitRating,
          qualityRating: this.qualityRating,
          photoAccuracyRating: this.photoAccuracyRating,
          body: this.review,
          pros: this.advantages,
          cons: this.disadvantages,
          recommended: this.recommended,
          authorName: this.name,
          locationName: this.cityValue.name,
          dimensions: this.size,
          timeUsage: this.timeUsage,
        });

        this.onClose();
      }
    }
  },
}
</script>

<style lang="scss">
  .review-modal .modal-content {
    max-width: 600px;
    padding: 0;
  }

  .review-form {
    &__title {
      font-size: 16px;
      line-height: 24px;
      font-weight: bold;
      margin-bottom: 16px;

      @include breakpoint("tablet") {
        font-size: 16px;
        line-height: 24px;
      }
    }

    &__inputs-wrap {
      margin: 24px;
    }

    &__inputs-wrap-user {
      @include breakpoint("tablet") {
        display: grid;
        grid-template-columns: 1fr 1fr;
        column-gap: 24px;
      }
    }

    &__stats-wrap {
      background: $blue_8;
      padding: 24px;

      @include breakpoint("tablet") {
        padding: 24px 24px 36px;
      }
    }

    &__main-rating {
      margin-bottom: 25px;

      @include breakpoint("desktop") {
        margin-bottom: 42px;
      }
    }

    &__secondary-rating {
      margin-bottom: 21px;
      @include breakpoint("tablet") {
        margin-bottom: 24px;
      }
    }

    &__offset-rating {
      margin-bottom: 25px;
    }

    &__size {
      margin-bottom: 32px;
    }

    .review-radio-stats {
      @include breakpoint("tablet") {
        .radio-group {
          display: flex;
          justify-content: space-between;
        }

        .ui-radio {
          flex: 1;
          margin-top: 10px;
        }
      }
    }

    &__textarea {
      margin-bottom: 24px;
    }

    &__textarea-label {
      margin-bottom: 12px;
    }

    &__checkbox {
      margin-bottom: 24px;
    }

    &__agreement {
      color: $gray;
      font-size: 12px;
      line-height: 16px;
      margin-top: 24px;

      a {
        color: $black;
      }
    }

    &__inputs-group {
      @include breakpoint("tablet") {
        display: flex;
        justify-content: space-between;
      }
    }

    &__inputs-wrap-text {
      @include breakpoint("tablet") {
        margin: 32px 24px;
      }
    }
  }
</style>
